import React, { useState } from 'react';

import Button from '../../../components/ui/Button';

const WeeklyCalendar = ({ 
  selectedDate, 
  onDateChange,
  classesData 
}) => {
  const [currentWeekStart, setCurrentWeekStart] = useState(
    new Date(selectedDate.getFullYear(), selectedDate.getMonth(), selectedDate.getDate() - selectedDate.getDay())
  );

  const weekDays = ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'];
  
  const getWeekDates = () => {
    const dates = [];
    for (let i = 0; i < 7; i++) {
      const date = new Date(currentWeekStart);
      date?.setDate(currentWeekStart?.getDate() + i);
      dates?.push(date);
    }
    return dates;
  };

  const navigateWeek = (direction) => {
    const newDate = new Date(currentWeekStart);
    newDate?.setDate(currentWeekStart?.getDate() + (direction * 7));
    setCurrentWeekStart(newDate);
  };

  const isToday = (date) => {
    const today = new Date();
    return date?.toDateString() === today?.toDateString();
  };

  const isSelected = (date) => {
    return date?.toDateString() === selectedDate?.toDateString();
  };

  const getClassCountForDate = (date) => {
    return classesData?.filter(cls => {
      const classDate = new Date(cls.date);
      return classDate?.toDateString() === date?.toDateString();
    })?.length;
  };

  const weekDates = getWeekDates();
  const monthYear = currentWeekStart?.toLocaleDateString('en-US', { month: 'long', year: 'numeric' });

  return (
    <div className="bg-card border border-border rounded-lg shadow-md p-4 md:p-5 lg:p-6">
      <div className="flex items-center justify-between mb-4 md:mb-6">
        <h2 className="text-lg md:text-xl lg:text-2xl font-heading font-semibold text-foreground">
          {monthYear}
        </h2>
        
        <div className="flex items-center gap-2">
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigateWeek(-1)}
            iconName="ChevronLeft"
            iconSize={16}
            className="w-8 h-8 md:w-10 md:h-10 p-0"
            aria-label="Previous week"
          />
          <Button
            variant="outline"
            size="sm"
            onClick={() => {
              const today = new Date();
              setCurrentWeekStart(new Date(today.getFullYear(), today.getMonth(), today.getDate() - today.getDay()));
              onDateChange(today);
            }}
            className="hidden md:flex"
          >
            Today
          </Button>
          <Button
            variant="outline"
            size="sm"
            onClick={() => navigateWeek(1)}
            iconName="ChevronRight"
            iconSize={16}
            className="w-8 h-8 md:w-10 md:h-10 p-0"
            aria-label="Next week"
          />
        </div>
      </div>
      <div className="grid grid-cols-7 gap-2 md:gap-3 lg:gap-4">
        {weekDates?.map((date, index) => {
          const classCount = getClassCountForDate(date);
          const today = isToday(date);
          const selected = isSelected(date);
          
          return (
            <button
              key={index}
              onClick={() => onDateChange(date)}
              className={`
                flex flex-col items-center justify-center p-2 md:p-3 lg:p-4 rounded-lg
                transition-smooth hover-lift press-scale
                ${selected 
                  ? 'bg-primary text-primary-foreground shadow-md' 
                  : today
                  ? 'bg-accent/10 text-accent border-2 border-accent' :'bg-muted text-foreground hover:bg-muted/80'
                }
              `}
              aria-label={`${weekDays?.[index]}, ${date?.toLocaleDateString('en-US', { month: 'short', day: 'numeric' })}`}
              aria-current={selected ? 'date' : undefined}
            >
              <span className="text-xs md:text-sm caption font-medium mb-1">
                {weekDays?.[index]}
              </span>
              <span className="text-lg md:text-xl lg:text-2xl font-heading font-bold mb-1">
                {date?.getDate()}
              </span>
              {classCount > 0 && (
                <div className="flex items-center gap-1">
                  <div className={`w-1 h-1 rounded-full ${selected ? 'bg-primary-foreground' : 'bg-accent'}`} />
                  <span className="text-[10px] md:text-xs caption font-medium">
                    {classCount}
                  </span>
                </div>
              )}
            </button>
          );
        })}
      </div>
    </div>
  );
};

export default WeeklyCalendar;